<template>
<div class="carousel-item">
    <div
        class="tmp3-feature"
        role="button" tabindex="-1"
        v-on:click.self="navigateToProductPage"
        v-on:keydown.enter="navigateToProductPage"
    >
        <div class="overlay">
            <NuxtLink :to="localeRoute({name: 'games-gameslug', params: {gameslug: 'trivia-murder-party-3'}})">
                <NuxtImg
                    tabindex="0"
                    src="/images/homepage/features/tmp3/tmp3-wordmark.png" alt="Trivia Murder Party 3"
                    class="wordmark" role="button"
                />
            </NuxtLink>
            <div class="notes">
                <p class="release-date"><i>{{ $t('PACK_DETAIL.COMING_SOON') }}!</i></p>
            </div>
            <NuxtLink :to="localeRoute({name: 'games-gameslug', params: {gameslug: 'trivia-murder-party-3'}})">
                <button class="outline wide icon-button">
                    <p>{{ $t('GAME_DETAIL.LEARN_MORE') }}</p>
                    <div class="icons">
                        <NuxtImg src="/images/icons/arrow-right.svg" alt="->" class="arrow-right" />
                    </div>
                </button>
            </NuxtLink>
        </div>
    </div>
</div>
</template>

<script lang="ts">
export default defineNuxtComponent({
    methods: {
        navigateToProductPage() {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            void this.$router.push(this.localeRoute({ name: 'games-gameslug', params: { packslug: 'trivia-murder-party-3' } }))
        }
    }
})
</script>

<style lang="scss" scoped>
@import "../../../styles/kit.scss";

.tmp3-feature {
    display: flex;
    width: 100%;
    height: 100%;
    background-image: url('/images/homepage/features/tmp3/tmp3-background.png');
    background-size: cover;
    background-position: right 0 bottom 11%;
    background-repeat: no-repeat;
    flex-direction: row;
    justify-content: space-between;
    position: relative;

    @include mq-xsmall {
        background-image: url('/images/homepage/features/tmp3/tmp3-background.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: top center;
        flex-direction: column;
        padding-bottom: 16px;
    }

    .overlay {
        margin: auto 80px;
        padding: 10px;
        max-width: 320px;
        display: flex;
        flex-direction: column;
        background: linear-gradient(108.46deg, rgba(182, 224, 255, 0.088) 0%, rgba(182, 224, 255, 0.132) 100%);
        backdrop-filter: blur(6.5px);
        border-radius: 10px;

        @include mq-medium {
            max-width: 280px;
        }

        @include mq-small {
            margin: auto 40px;
            max-width: 320px;
            min-width: 220px;
            width: 35vw;
        }

        @include mq-xsmall {
            margin: 0;
            margin-top: 50px;
            flex-direction: column;
            width: 100%;
            align-self: center;
        }

        .notes {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            margin-bottom: 5px;

            .platform-info {
                display: flex;
                align-items: center;
                gap: 5px;

                img {
                    height: 14px;
                    width: 14px;
                }

                p {
                    margin: 0;
                    font-size: 12px;
                    line-height: 12px;
                }
            }

            .release-date {
                display: flex;
                align-items: center;
                margin: 0;
                font-style: italic;
                font-weight: 600;
                font-size: 12px;
                line-height: 12px;
                text-transform: uppercase;
                text-align: right;
            }
        }

        button {
            height: 48px;
            font-size: 16px;
            line-height: 16px;
            margin: 0;
            text-align: left;

            &.primary-gradient {
                font-weight: 800;
                text-transform: uppercase;
                margin: 10px 0px;
            }

            &.outline {
                &:hover {
                    border: 2.5px solid var(--primary-200);
                    color: var(--primary-200);
                    .arrow-right {
                        filter: brightness(0) saturate(100%) invert(82%) sepia(30%) saturate(3659%)
                        hue-rotate(191deg) brightness(103%) contrast(101%);
                    }
                }
            }

            @include mq-small-and-less {
                font-size: 14px;
                line-height: 14px;
                width: 280px
            }
        }

        .icon-button {
            p {
                margin: 0;
            }

            display: flex;
            align-items: center;
            justify-content: space-between;

            .icons {
                display: flex;
                gap: 8px;
                align-items: center;

                img {
                    &.arrow-right {
                        height: 18px;
                        width: 15.429px;
                    }

                    &.windows {
                        height: 16px;
                        width: 17px;
                    }

                    &.apple {
                        height: 16px;
                        width: 14px;
                    }

                    &.linux {
                        height: 18px;
                        width: 15px;
                    }

                    @include mq-small-and-less {
                        &.arrow-right {
                            height: 16px;
                            width: 13.715px;
                        }
                    }
                }
            }
        }

        .wordmark {
            width: 100%;
            transition: transform .2s;
            cursor: pointer;
            &:hover {
                transform: scale(1.10)
            }
        }
    }
}
</style>
